/* eslint-disable react/prop-types */

import React from "react";
import Typeography from "@material-ui/core/Typography";

const Errors = ({ postError }) => {
  const { detail } = postError;
  return typeof detail === "string" || detail instanceof String ? (
    <Typeography color="error">{detail}</Typeography>
  ) : (
    <Typeography color="error">Please check the form for errors.</Typeography>
  );
};

export default Errors;
